export default function EquipmentMockService($http, $q, gettextCatalog) {
  'ngInject';

  this.getEquipment = function (equipmentId) {
    if (!equipmentId) {
      return $http.get('./app/fixtures/equipment.search.json');
    }

    var def = $q.defer();
    $http.get('./app/fixtures/equipment.search.json').then(
      function (response) {
        for (var i = 0; i < response.data.hits.length; i++) {
          if (response.data.hits[i]) {
            if (response.data.hits[i].id == equipmentId) {
              response.data = response.data.hits[i];
              return def.resolve(response);
            }
          }
        }
        return def.reject(gettextCatalog.getString('Id not in fixtures'));
      },
      function (response) {
        return def.reject(response);
      }
    );
    return def.promise;
  };

  this.getEquipmentSearch = () => $http.get('./app/fixtures/equipment.search.json');
  this.getEquipmentSeries = () => $http.get('./app/fixtures/equipment.series.json');
}